//import action types
import * as types from "../actions/types"

const initialState = {
  topProfilesData: [],
  error: []
};

const topFiveProfilesReducer = (variable = initialState, action) => {
    const { type, payload } = action
    switch(action.type) {
        case types.topFiveProfiles:
          return{
            ...variable,
            topProfilesData: action.payload
          }
        default:
            return variable
    }
}

export default topFiveProfilesReducer